import { useContext, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useStore } from 'zustand';
import { useShallow } from 'zustand/shallow';

import { HotelContext } from 'app/context/HotelContext/HotelContext';
import { useHotelUnavailable } from 'app/hooks/data/core/extranet/inventory/useHotelUnavailable';

import { InventoryTabItemName, inventoryStore } from '../InventoryStore';

const TAB_PARAM = 'tab';
const PRICING_PARAM = 'pricing-config';
const NO_STOCK_PARAM = 'noStock';

const URL_TO_TAB: Record<string, InventoryTabItemName> = {
  packages: InventoryTabItemName.Packs,
  rooms: InventoryTabItemName.Rooms,
  activities: InventoryTabItemName.Experiences,
};

const TAB_TO_URL: Record<InventoryTabItemName, string> = {
  [InventoryTabItemName.Packs]: 'packages',
  [InventoryTabItemName.Rooms]: 'rooms',
  [InventoryTabItemName.Experiences]: 'activities',
};

export const useInventoryQueryParams = () => {
  const { hotelId } = useContext(HotelContext);
  const history = useHistory();
  const location = useLocation();
  const { mutate: setHotelUnavailable } = useHotelUnavailable(hotelId);

  const { tab, isPricingDrawerOpened, changeTab, setPricingDrawerOpen } =
    useStore(
      inventoryStore,
      useShallow((state) => ({
        tab: state.tab,
        isPricingDrawerOpened: state.isPricingDrawerOpened,
        changeTab: state.changeTab,
        setPricingDrawerOpen: state.setPricingDrawerOpen,
      }))
    );

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tabParam = params.get(TAB_PARAM);
    const pricingParam = params.get(PRICING_PARAM);

    if (tabParam && URL_TO_TAB[tabParam]) {
      changeTab({ name: URL_TO_TAB[tabParam] });
    }

    if (pricingParam === 'true') {
      setPricingDrawerOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- legacy directive, needs investigation
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    if (params.has(NO_STOCK_PARAM)) {
      setHotelUnavailable();
      params.delete(NO_STOCK_PARAM);
      history.replace({ search: params.toString() });
    }
  }, [history, location.search, setHotelUnavailable]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    params.set(TAB_PARAM, TAB_TO_URL[tab.name]);

    if (isPricingDrawerOpened) {
      params.set(PRICING_PARAM, 'true');
    } else {
      params.delete(PRICING_PARAM);
    }

    history.replace({ search: params.toString() });
  }, [tab, isPricingDrawerOpened, history]);
};
